// src/components/public/PageLoader.js
// Full-screen spinner shown while a public page waits for its remote stylesheet. Styles: pages/chrome.css
import React from "react";

const PageLoader = () => (
  <div className="loader-wrapper" role="status" aria-label="Loading">
    <div className="loader" />
  </div>
);

export default PageLoader;
